import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { Subject }    from 'rxjs/Subject';

import { ApiService } from '../../root-services/api.service';

import { Admin } from './../../models/program/admin';
import { NewAndExistingUsers } from '../../models/program/new-and-existing-users';

export interface AdminPatch {
  edition_admin?: boolean,
  resource_editor?: boolean,
  comment_moderator?: boolean
}

@Injectable()
export class AdminService {

  private _admins: Observable<Admin[]>;
  private readonly _adminSubject = new Subject<Admin[]>();

  constructor(private api: ApiService) { }

  public getAdmins(): Observable<Admin[]> {
    // if (!this._admins) {
      this._admins = this.api.get('/admins')
                             .map(response => response.json() as Admin[])
                             .publishReplay(1).refCount()
                             .catch(this.handleError);
      // pass value onto the admin subject so that any existing subscribers
      // from previous calls to getAdmin will also be updated
      this._admins.subscribe(adminArray => this._adminSubject.next(adminArray))
    // }

    return this._adminSubject.asObservable();
  }

  public patchAdmin(id: number, adminPatch: AdminPatch): Observable<Response> {
    return this.api.patch(`/admins/${id}`, adminPatch)
                   .map(() => {})
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public deleteAdmin(id: number): Observable<Response> {
    return this.api.delete(`/admins/${id}`)
                   .map(() => {})
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public makeAdmins(adminArray: NewAndExistingUsers): Observable<Response> {
    return this.api.post(`/admins/actions/make_global_admins`, adminArray)
                   .map(() => {})
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  /**
   * Private Methods
   */

  private handleError(error: any): Promise<any> {
    console.error('An error occured:', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/administrators/admin.service.ts